import React, { useEffect } from "react";
import './OpalDashboardLayout.css';
import OpalHostContainer from "./OpalHostContainer/OpalHostContainer";

const OpalDashboardLayout = () => {

    const itemSections = [
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "attendance",
                "colorTheme": "colorTheme1",
                "title": "TODAY'S ATTENDANCE",
                "binding": {
                    "data": {
                        "columns": [

                        ],
                        "title": '',
                        "endpoint": "R13",
                        "parameters": [
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "cyclePeriod",
                "colorTheme": 'colorTheme1',
                "title": "CURRENT CYCLE",
                "binding": {
                    "data": {
                        "endpoint": "R14",
                        "parameters": []
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "advancedGuageDial",
                "colorTheme": 'colorTheme1',
                "title": "REMAINING CALLS TODAY",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "title": "Title",
                        "value": 'Progress',
                        "total": 'Total',
                        "endpoint": "R1",
                        "parameters": [
                            { "key": "start_date", "value": "2023-01-01" },
                            { "key": "end_date", "value": "2023-12-31" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "count",
                "colorTheme": 'colorTheme1',
                "title": "PENDING CALLS",
                "binding": {
                    "data": {
                        "value": 'Pending',
                        "endpoint": "R2",
                        "parameters": []
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "advancedGuage",
                "colorTheme": 'colorTheme1',
                "title": "CALL RATE",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "title": "Title",
                        "value": 'Progress',
                        "total": 'Total',
                        "endpoint": "R3",
                        "parameters": [
                            { "key": "start_date", "value": "2023-01-01" },
                            { "key": "end_date", "value": "2023-12-31" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "advancedGuage",
                "colorTheme": 'colorTheme1',
                "title": "CALL REACH",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "title": "Title",
                        "value": 'Progress',
                        "total": 'Total',
                        "endpoint": "R4",
                        "parameters": [
                            { "key": "start_date", "value": "2023-01-01" },
                            { "key": "end_date", "value": "2023-12-31" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "advancedGuage",
                "colorTheme": 'colorTheme1',
                "title": "CALL FREQUENCY",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "title": "Title",
                        "value": 'Progress',
                        "total": 'Total',
                        "endpoint": "R5",
                        "parameters": [
                            { "key": "start_date", "value": "2023-01-01" },
                            { "key": "end_date", "value": "2023-12-31" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "bar",
                "colorTheme": 'colorTheme2',
                "title": "MISSED CALLS",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "series": [
                            {
                                "name": 'Count',
                                "value": 'Value',
                                "type": 'column'

                            }
                        ],
                        "title": 'SubCycle',
                        "endpoint": "R6",
                        "parameters": [
                            { "key": "FromMonth", "value": "1" },
                            { "key": "FromYear", "value": "2025" },
                            { "key": "ToMonth", "value": "1" },
                            { "key": "ToYear", "value": "2025" },
                            { "key": "ConfigTypeCode", "value": "Y2025" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CycleIndex",
                                "selectedTitle": "",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": 'colorTheme1',
                                            "title": "Missed Call Sessions",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Status',
                                                            "columnName": 'Status',
                                                            "width": '120px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Account Name',
                                                            "columnName": 'AccountName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Date',
                                                            "columnName": 'SessionDate',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        }
                                                    ],
                                                    "title": "AccountName",
                                                    "endpoint": "R6.1",
                                                    "parameters": [
                                                        { "key": "CycleIndex", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "bar",
                "colorTheme": 'colorTheme3',
                "title": "INCIDENTAL CALLS",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "series": [
                            {
                                "name": 'Count',
                                "value": 'Value',
                                "type": 'column'

                            },
                        ],
                        "title": 'SubCycle',
                        "endpoint": "R7",
                        "parameters": [
                            { "key": "FromMonth", "value": "1" },
                            { "key": "FromYear", "value": "2025" },
                            { "key": "ToMonth", "value": "1" },
                            { "key": "ToYear", "value": "2025" },
                            { "key": "ConfigTypeCode", "value": "Y2025" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CycleIndex",
                                "selectedTitle": "",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": 'colorTheme1',
                                            "title": "Incidental Call Sessions",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Status',
                                                            "columnName": 'Status',
                                                            "width": '120px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Account Name',
                                                            "columnName": 'AccountName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Date',
                                                            "columnName": 'SessionDate',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        }
                                                    ],
                                                    "title": "AccountName",
                                                    "endpoint": "R7.1",
                                                    "parameters": [
                                                        { "key": "CycleIndex", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "bar",
                "colorTheme": 'colorTheme4',
                "title": "ADVANCED CALLS",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "series": [
                            {
                                "name": 'Count',
                                "value": 'Value',
                                "type": 'column'

                            }
                        ],
                        "title": 'SubCycle',
                        "endpoint": "R8",
                        "parameters": [
                            { "key": "FromMonth", "value": "1" },
                            { "key": "FromYear", "value": "2025" },
                            { "key": "ToMonth", "value": "1" },
                            { "key": "ToYear", "value": "2025" },
                            { "key": "ConfigTypeCode", "value": "Y2025" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CycleIndex",
                                "selectedTitle": "",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": 'colorTheme1',
                                            "title": "Advanced Call Sessions",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Status',
                                                            "columnName": 'Status',
                                                            "width": '120px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Account Name',
                                                            "columnName": 'AccountName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Date',
                                                            "columnName": 'SessionDate',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        }
                                                    ],
                                                    "title": "AccountName",
                                                    "endpoint": "R8.1",
                                                    "parameters": [
                                                        { "key": "CycleIndex", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "bar",
                "colorTheme": 'colorTheme5',
                "title": "RECOVERED CALLS",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "series": [
                            {
                                "name": 'Count',
                                "value": 'Value',
                                "type": 'column'

                            }
                        ],
                        "title": 'SubCycle',
                        "endpoint": "R9",
                        "parameters": [
                            { "key": "FromMonth", "value": "1" },
                            { "key": "FromYear", "value": "2025" },
                            { "key": "ToMonth", "value": "1" },
                            { "key": "ToYear", "value": "2025" },
                            { "key": "ConfigTypeCode", "value": "Y2025" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CycleIndex",
                                "selectedTitle": "",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": 'colorTheme1',
                                            "title": "Recovered Call Sessions",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Status',
                                                            "columnName": 'Status',
                                                            "width": '120px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Account Name',
                                                            "columnName": 'AccountName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Date',
                                                            "columnName": 'SessionDate',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        }
                                                    ],
                                                    "title": "AccountName",
                                                    "endpoint": "R9.1",
                                                    "parameters": [
                                                        { "key": "CycleIndex", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "bar",
                "colorTheme": 'colorTheme6',
                "title": "JOINT CALLS",
                "orientation": "vertical",
                "xAxis": "",
                "yAxis": "",
                "binding": {
                    "data": {
                        "series": [
                            {
                                "name": 'Count',
                                "value": 'Value',
                                "type": 'column'

                            }
                        ],
                        "title": 'SubCycle',
                        "endpoint": "R10",
                        "parameters": [
                            { "key": "FromMonth", "value": "1" },
                            { "key": "FromYear", "value": "2025" },
                            { "key": "ToMonth", "value": "1" },
                            { "key": "ToYear", "value": "2025" },
                            { "key": "ConfigTypeCode", "value": "Y2025" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {
                                "selectedValueColumn": "CycleIndex",
                                "selectedTitle": "",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": 'colorTheme1',
                                            "title": "Joint Call Sessions",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Status',
                                                            "columnName": 'Status',
                                                            "width": '120px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Account Name',
                                                            "columnName": 'AccountName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        },
                                                        {
                                                            "name": 'Date',
                                                            "columnName": 'SessionDate',
                                                            "width": '200px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false,
                                                        }
                                                    ],
                                                    "title": "AccountName",
                                                    "endpoint": "R10.1",
                                                    "parameters": [
                                                        { "key": "CycleIndex", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    }
                }
            }
        },
        {
            "columns": 9,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "summary",
                "colorTheme": 'colorTheme1',
                "title": "SALES SUMMARY",
                "binding": {
                    "data": {
                        "endpoint": "R11",
                        "parameters": [
                            { "key": "start_date", "value": "2023-01-01" },
                            { "key": "end_date", "value": "2023-12-31" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        },
        {
            "columns": 3,
            "rows": 1,
            "visual": {
                "id": 1,
                "type": "announcement",
                "colorTheme": 'colorTheme1',
                "title": "RECENT ANNOUNCEMENTS",
                "binding": {
                    "data": {
                        "endpoint": "R12",
                        "parameters": [
                            { "key": "start_date", "value": "2023-01-01" },
                            { "key": "end_date", "value": "2023-12-31" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": {}
                        }
                    }
                }
            }
        }
    ]

    const chartPalettes = [
        {
            "id": "palette1",
            "ranges": ["#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7"]
        },
        {
            "id": "palette2",
            "ranges": ["#F5CBCB", "#FFCD7F", "#00AAE7", "#58B341", "#13269E", "#FFCD7F", "#00AAE7", "#58B341"]
        },
        {
            "id": "palette3",
            "ranges": ["#D4C2F9", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette4",
            "ranges": ["#FFD79A", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette5",
            "ranges": ["#CFCFCF", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette6",
            "ranges": ["#00BE66", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette7",
            "ranges": ["#FFDD63", "#00AAE7", "#13269E", "#58B341", "#FFCD7F", "#00AAE7", "#13269E", "#58B341"]
        },
        {
            "id": "palette8",
            "ranges": ['#ECF6FF', '#CCCCCC', '#FFBD59', '#FFD23F', '#000000']
        }
    ]

    const chartThemes = [
        {
            "id": "colorTheme1",
            "name": "colorTheme1",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette1"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette1"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
                {
                    "type": "count",
                    "ranges": ["palette1"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette1"]
                },
                {
                    "type": "birthdayReminder",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedGuage",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedGuageDial",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette8"]
                }
            ]
        },
        {
            "id": "colorTheme2",
            "name": "colorTheme2",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette2"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette2"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette2"]
                }
            ]
        },
        {
            "id": "colorTheme3",
            "name": "colorTheme3",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette3"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette3"]
                },
            ]
        },
        {
            "id": "colorTheme4",
            "name": "colorTheme4",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette4"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette4"]
                },
            ]
        },
        {
            "id": "colorTheme5",
            "name": "colorTheme5",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette5"]
                },
            ]
        },
        {
            "id": "colorTheme6",
            "name": "colorTheme6",
            "charts": [
                {
                    "type": "attendance",
                    "ranges": ["palette6"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette6"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette6"]
                }
            ]
        }
    ]

    useEffect(() => {
        const getvalue = localStorage.getItem('permission');
    }, [])

    return (
        <div className="row">
            <main className="flex-grow-1 col-md-9 col-lg-9 p-0 m-0">
                <div className='host-container' tag="main">
                    <div className="opal-dashboard-layout-container d-flex h-100">
                        <OpalHostContainer
                            itemSection={itemSections}
                            chartPalette={chartPalettes}
                            chartTheme={chartThemes}
                            autoScale={true}
                        />
                    </div>
                </div>
            </main>
        </div>
    );
};

export default OpalDashboardLayout;
